import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

export const AUTH_MACHINE_ID = 'AUTH_MACHINE'

export const loginMachineStates = {
   loginState: 'loginState',
   otpState: 'otpState',
   requestEmailOtpState: 'requestEmailOtpState',
   requestEmailOtpFailedState: 'requestEmailOtpFailedState',
   verifyEmailOtpState: 'verifyEmailOtpState',
   verifyEmailOtpFailedState: 'verifyEmailOtpFailedState',
   resendEmailOtpState: 'resendEmailOtpState',
   resendEmailOtpFailedState: 'resendEmailOtpFailedState',

   requestUsernameOtpState: 'requestUsernameOtpState',
   requestUsernameOtpFailedState: 'requestUsernameOtpFailedState',
   verifyUsernameOtpState: 'verifyUsernameOtpState',
   verifyUsernameOtpFailedState: 'verifyUsernameOtpFailedState',
   resendUsernameOtpState: 'resendUsernameOtpState',
   resendUsernameOtpFailedState: 'resendUsernameOtpFailedState',
   loginSuccess: 'loginSuccess'
}

export const loginMachineEvents = {
   requestEmailOtp: 'requestEmailOtp',
   onChangeEmailOtp: 'onChangeEmailOtp',
   verifyEmailOtp: 'verifyEmailOtp',
   resendEmailOtp: 'resendEmailOtp',

   requestUsernameOtp: 'requestUsernameOtp',
   onChangeUsernameOtp: 'onChangeUsernameOtp',
   verifyUsernameOtp: 'verifyUsernameOtp',
   resendUsernameOtp: 'resendUsernameOtp',

   retryFailedApi: 'retryFailedApi',
   goBack: 'goBack',
   onChangeValue: 'onChangeValue',
   onChangeOTP: 'onChangeOTP',
   clearErrorMessage: 'clearErrorMessage'
} as const

export const loginMachineTags = {
   requestOtpLoading: 'requestOtpLoading',
   verifyOtpLoading: 'verifyOtpLoading',
   resendOtpLoading: 'resendOtpLoading',
   loginScreen: 'loginScreen',
   otpScreen: 'otpScreen',
   apiFailure: 'apiFailure'
}

export const NO_OF_OTP_BOXES = 6

export const RESEND_TIME_IN_SECONDS = 120

export const stepNames = {
   verificationStep: 'verification-step'
}

export enum EnvironmentSelectorEnum {
   Alpha = 'Alpha',
   Beta = 'Beta',
   Gamma = 'Gamma',
   Others = 'Others'
}

export const LOGIN_VERSION: LoginVersionEnum = Config.LOGIN_VERSION

export enum LoginVersionEnum {
   DEFAULT_CRM_LOGIN = 'DEFAULT_CRM_LOGIN',
   B2G_TG_LOGIN = 'B2G_TG_LOGIN'
}

export const LOGIN_USERNAME_COOKIE_NAME = 'fw_u_id'

export const LOGIN_USERNAME_COOKIE_EXPIRY_DAYS = 365
